function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { EwmaBandwidthEstimator } from './ewma-bandwidth-estimator';
import { filterAndSortVariants } from './utils';
import { sdkLogger } from '../../../../logger';
export var SimpleAbrManager = /*#__PURE__*/ function() {
    "use strict";
    function SimpleAbrManager() {
        _class_call_check(this, SimpleAbrManager);
        _define_property(this, "switchCallback", null);
        _define_property(this, "enabled", false);
        _define_property(this, "bandwidthEstimator", void 0);
        _define_property(this, "config", void 0);
        _define_property(this, "variants", []);
        _define_property(this, "playbackRate", 1);
        _define_property(this, "lastTimeChosenMs", null);
        _define_property(this, "chosenVariant", null);
        _define_property(this, "logger", void 0);
        _define_property(this, "startupComplete", false);
        this.bandwidthEstimator = new EwmaBandwidthEstimator();
        if (navigator.connection && navigator.connection.addEventListener) {
            navigator.connection.addEventListener('change', this.onConnectionChangeEvent.bind(this));
        }
        this.logger = sdkLogger.withContext('CVSDK Simple Abr Manager');
    }
    _create_class(SimpleAbrManager, [
        {
            key: "onConnectionChangeEvent",
            value: function onConnectionChangeEvent() {
                var _this_config;
                if (this.enabled && ((_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.useNetworkInformation)) {
                    this.bandwidthEstimator = new EwmaBandwidthEstimator();
                    if (this.config && this.config.advanced) {
                        this.bandwidthEstimator.configure(this.config.advanced);
                    }
                    var chooseVariant = this.chooseVariant();
                    if (chooseVariant && navigator.onLine && this.switchCallback) {
                        this.switchCallback(chooseVariant, this.config.clearBufferSwitch, this.config.safeMarginSwitch);
                    }
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.switchCallback = null;
                this.enabled = false;
                this.variants = [];
                this.playbackRate = 1;
                this.lastTimeChosenMs = null;
            }
        },
        {
            key: "release",
            value: function release() {
                if (navigator.connection && navigator.connection.removeEventListener) {
                    navigator.connection.removeEventListener('change', this.onConnectionChangeEvent.bind(this));
                }
            }
        },
        {
            key: "init",
            value: function init(switchCallback) {
                this.switchCallback = switchCallback;
            }
        },
        {
            key: "chooseVariant",
            value: function chooseVariant() {
                var sortedVariants = this.getSortedVariants();
                var defaultBandwidthEstimate = this.getDefaultBandwidth();
                var currentBandwidth = this.bandwidthEstimator.getBandwidthEstimate(defaultBandwidthEstimate);
                var config = this.config;
                // Start by assuming that we will use the first Stream.
                var chosen = sortedVariants[0] || null;
                for(var i = 0; i < sortedVariants.length; i++){
                    var item = sortedVariants[i];
                    var playbackRate = !isNaN(this.playbackRate) ? Math.abs(this.playbackRate) : 1;
                    var itemBandwidth = playbackRate * item.bandwidth;
                    var minBandwidth = itemBandwidth / config.bandwidthDowngradeTarget;
                    var next = {
                        bandwidth: Infinity
                    };
                    for(var j = i + 1; j < sortedVariants.length; j++){
                        if (item.bandwidth != sortedVariants[j].bandwidth) {
                            next = sortedVariants[j];
                            break;
                        }
                    }
                    var nextBandwidth = playbackRate * next.bandwidth;
                    var maxBandwidth = nextBandwidth / config.bandwidthUpgradeTarget;
                    if (currentBandwidth >= minBandwidth && currentBandwidth <= maxBandwidth && chosen.bandwidth != item.bandwidth || this.isSameBandwidthAndHigherResolution(chosen, item)) {
                        chosen = item;
                    }
                }
                this.lastTimeChosenMs = Date.now();
                this.chosenVariant = chosen;
                return chosen;
            }
        },
        {
            key: "getDefaultBandwidth",
            value: function getDefaultBandwidth() {
                var _this_config;
                // the below assumption that config is defined is safe as configure will always have been called.
                var defaultBandwidthEstimate = this.config.defaultBandwidthEstimate;
                // Some browsers implement the Network Information API, which allows
                // retrieving information about a user's network connection.  Tizen 3 has
                // NetworkInformation, but not the downlink attribute.
                if (navigator.connection && navigator.connection.downlink && ((_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.useNetworkInformation)) {
                    // If it's available, get the bandwidth estimate from the browser (in
                    // megabits per second) and use it as defaultBandwidthEstimate.
                    defaultBandwidthEstimate = navigator.connection.downlink * 1e6;
                }
                return defaultBandwidthEstimate;
            }
        },
        {
            key: "getSortedVariants",
            value: function getSortedVariants() {
                // the below assumption that config is defined is safe as configure will always have been called.
                var sortedVariants = filterAndSortVariants(this.config.restrictions, this.variants);
                // If we couldn't meet the ABR restrictions, we should still play
                // something.
                // These restrictions are not "hard" restrictions in the way that
                // top-level or DRM-based restrictions are.  Sort the variants without
                // restrictions and keep just the first (lowest-bandwidth) one.
                if (this.variants.length && !sortedVariants.length) {
                    sortedVariants = filterAndSortVariants(null, this.variants);
                    sortedVariants = [
                        sortedVariants[0]
                    ];
                }
                return sortedVariants;
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        },
        {
            key: "segmentDownloaded",
            value: function segmentDownloaded(deltaTimeMs, numBytes, allowSwitch, request) {
                if (deltaTimeMs < 0) {
                    this.logger.warn('expected a non-negative duration');
                }
                var hasTimedout = numBytes === -1;
                // Disregards network timeouts for the bw estimation
                // since the data from real progress updates should be enough
                if (!hasTimedout) {
                    this.bandwidthEstimator.sample(deltaTimeMs, numBytes);
                }
                if (this.lastTimeChosenMs != null && this.enabled) {
                    var _this_config;
                    if (hasTimedout && ((_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.forceLowestRateOnTimeout)) {
                        // the request timedout
                        // let's go straight to the lowest bitrate
                        this.downgradeToLowestRate();
                    } else {
                        this.suggestStreams(hasTimedout);
                    }
                }
            }
        },
        {
            key: "downgradeToLowestRate",
            value: function downgradeToLowestRate() {
                var _this_switchCallback, _this;
                if (this.lastTimeChosenMs === null) {
                    this.logger.warn('lastTimeChosenMs should not be null');
                }
                var previousVariant = this.chosenVariant;
                var sortedVariants = this.getSortedVariants();
                var chosen = sortedVariants[0];
                if (chosen === previousVariant) {
                    this.logger.info('Bitrate downgrade not available');
                    return;
                }
                this.lastTimeChosenMs = Date.now();
                this.chosenVariant = chosen;
                (_this_switchCallback = (_this = this).switchCallback) === null || _this_switchCallback === void 0 ? void 0 : _this_switchCallback.call(_this, chosen);
            }
        },
        {
            key: "suggestStreams",
            value: function suggestStreams(hasTimedout) {
                // the below assumption that config is defined is safe as configure will always have been called.
                var config = this.config;
                if (this.lastTimeChosenMs === null) {
                    this.logger.warn('lastTimeChosenMs should not be null');
                }
                if (!this.startupComplete) {
                    // Check if we've got enough data yet.
                    if (!this.bandwidthEstimator.hasGoodEstimate()) {
                        this.logger.verbose('Still waiting for a good estimate...');
                        return;
                    }
                    this.startupComplete = true;
                } else if (!hasTimedout && this.lastTimeChosenMs) {
                    // Check if we've left the switch interval.
                    var now = Date.now();
                    var delta = now - this.lastTimeChosenMs;
                    if (delta < config.switchInterval * 1000) {
                        return;
                    }
                }
                var chosenVariant = this.chooseVariant();
                var defaultBandwidthEstimate = this.getDefaultBandwidth();
                var bandwidthEstimate = this.bandwidthEstimator.getBandwidthEstimate(defaultBandwidthEstimate);
                var currentBandwidthKbps = Math.round(bandwidthEstimate / 1000.0);
                if (chosenVariant) {
                    var // If any of these chosen streams are already chosen, Player will filter
                    // them out before passing the choices on to StreamingEngine.
                    _this_switchCallback, _this;
                    this.logger.verbose('Calling switch_(), bandwidth=' + currentBandwidthKbps + ' kbps, variant:', chosenVariant);
                    (_this_switchCallback = (_this = this).switchCallback) === null || _this_switchCallback === void 0 ? void 0 : _this_switchCallback.call(_this, chosenVariant, config.clearBufferSwitch, config.safeMarginSwitch);
                }
            }
        },
        {
            key: "getBandwidthEstimate",
            value: function getBandwidthEstimate() {
                // the below assumption that config is defined is safe as configure will always have been called.
                var config = this.config;
                var defaultBandwidthEstimate = config.defaultBandwidthEstimate;
                // Some browsers implement the Network Information API, which allows
                // retrieving information about a user's network connection.  Tizen 3 has
                // NetworkInformation, but not the downlink attribute.
                if (navigator.connection && navigator.connection.downlink && config.useNetworkInformation) {
                    // If it's available, get the bandwidth estimate from the browser (in
                    // megabits per second) and use it as defaultBandwidthEstimate.
                    defaultBandwidthEstimate = navigator.connection.downlink * 1e6;
                }
                return defaultBandwidthEstimate;
            }
        },
        {
            key: "playbackRateChanged",
            value: function playbackRateChanged(playbackRate) {
                this.playbackRate = playbackRate;
            }
        },
        {
            key: "setVariants",
            value: function setVariants(variants) {
                this.variants = variants;
            }
        },
        {
            key: "configure",
            value: function configure(config, player) {
                this.config = config;
                if (this.bandwidthEstimator && this.config) {
                    this.bandwidthEstimator.configure(this.config.advanced);
                }
            }
        },
        {
            key: "isSameBandwidthAndHigherResolution",
            value: function isSameBandwidthAndHigherResolution(chosenVariant, newVariant) {
                if (chosenVariant === null) {
                    return false;
                }
                if (chosenVariant.bandwidth != newVariant.bandwidth) {
                    return false;
                }
                if (!chosenVariant.video || !newVariant.video) {
                    return false;
                }
                return chosenVariant.video.width < newVariant.video.width || chosenVariant.video.height < newVariant.video.height;
            }
        }
    ]);
    return SimpleAbrManager;
}();

//# sourceMappingURL=simple-abr-manager.js.map